<template>
  <div class="dls">
    <!-- header -->
    <div v-if="isLogin" class="ilsogin">
      <!-- <div :class="`survey_header${navIndexs} survey_header`">
        <div>
          <h1>{{ title }}</h1>
          <p>{{ title2 }}</p>
        </div>
      </div> -->
      
      <keep-alive>
        <router-view @handleTKD="handleBanner"></router-view>
      </keep-alive>
    </div>
    <!-- 尾部 -->
    <!-- <Footer /> -->
  </div>
</template>
<script type="text/ecmascript-6">
// import Footer from "./hwb/bottom";
import Footer from "../components/Foot";
import Bus from "../components/bus";
export default {
  components: { Footer },
  data() {
    return {
      isLogin: true,
      title: "",
      navIndexs: 0,
      title2: "",
    };
  },
  created() {
    //隐藏除登录以外的内容
    Bus.$on("isLoginFun", (flag) => {
      this.isLogin = flag;
      // console.log(flag)
    });
  },
  methods: {
    // 改变二级banner
    handleBanner(v) {
      switch (v) {
        case "走进外大":
          this.navIndexs = 0;
          this.title = "走进外大";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
        case "本科入学":
          this.navIndexs = 1;
          this.title = "本科入学";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
        case "中文MBA":
          this.navIndexs = 2;
          this.title = "中文MBA";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
        case "报名入口":
          this.navIndexs = 3;
          this.title = "报名入口";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
        case "录取查询":
          this.navIndexs = 4;
          this.title = "录取查询";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
        case "了解我们":
          this.navIndexs = 5;
          this.title = "了解我们";
          this.title2 = "Hankuk University of Foreign Studies";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scope>
.dls {
  .survey_header {
    margin-top: 170px;
    height: 200px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    div {
      h1 {
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 1px;
      }
      p {
        margin-top: 22px;
        font-size: 17px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
      }
      h1,
      p {
        margin-left: 95px;
      }
    }
  }
  .survey_header0 {
    // background: url("../assets/images/banner01.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey_header1 {
    // background: url("../assets/images/banner02.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey_header2 {
    // background: url("../assets/images/banner03.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey_header3 {
    // background: url("../assets/images/banner04.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey_header4 {
    // background: url("../assets/images/banner05.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey_header5 {
    // background: url("../assets/images/banner06.png") no-repeat center/cover;
    background-size: 100% 100%;
  }
  .survey {
    max-width: 100%;
    img {
      display: block;
      max-width: 100%;
    }
  }
}
</style>
